import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-562eb80a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lms-catalog" }
const _hoisted_2 = {
  key: 0,
  class: "loading-screen"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "lms-intro" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lms-intro__eyebrow" }, "Meine Aufgaben", -1))
const _hoisted_7 = { class: "lms-intro__title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lms-intro__sub" }, " Hier finden Sie Ihre zugewiesenen Kurse und Unterweisungen. Klicken Sie auf eine Aufgabe, um zu starten oder fortzufahren. ", -1))
const _hoisted_9 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-icon" }, "📚", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Keine Aufgaben zugewiesen", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ihnen wurden noch keine Kurse oder Unterweisungen zugewiesen. Bitte wenden Sie sich an Ihre Verwaltung.", -1))
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "modules-grid"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "module-card__image" }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = {
  key: 1,
  class: "module-card__image-ph"
}
const _hoisted_19 = {
  key: 0,
  class: "module-card__badge"
}
const _hoisted_20 = { class: "module-card__provider" }
const _hoisted_21 = { class: "module-card__title" }
const _hoisted_22 = { class: "module-card__desc" }
const _hoisted_23 = { class: "module-card__footer" }
const _hoisted_24 = { class: "module-card__duration" }
const _hoisted_25 = { class: "module-card__category" }
const _hoisted_26 = { class: "btn-start" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "module-card__image module-card__doc" }
const _hoisted_29 = {
  key: 0,
  class: "module-card__badge"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-card__provider" }, "Eigene Unterweisung", -1))
const _hoisted_31 = { class: "module-card__title" }
const _hoisted_32 = { class: "module-card__desc" }
const _hoisted_33 = { class: "btn-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_text_icon = _resolveComponent("file-text-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("h1", _hoisted_7, "Willkommen" + _toDisplayString(_ctx.firstName ? ', ' + _ctx.firstName : ''), 1),
            _hoisted_8
          ]),
          (_ctx.allCourseItems.length === 0 && _ctx.myInstructions.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_13))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCourseItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'course-' + item.courseId,
                    class: _normalizeClass(["module-card", { completed: _ctx.isCompleted(item.courseId) }]),
                    onClick: ($event: any) => (_ctx.openModule(item.courseId))
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      (item.module?.image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: item.module.image,
                            alt: item.module?.title || ''
                          }, null, 8, _hoisted_17))
                        : (_openBlock(), _createElementBlock("div", _hoisted_18))
                    ]),
                    (_ctx.isCompleted(item.courseId))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Abgeschlossen ✓ "))
                      : _createCommentVNode("", true),
                    (item.deadline)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["module-card__deadline", { overdue: _ctx.isOverdue(item.deadline) }])
                        }, " Frist: " + _toDisplayString(_ctx.formatDate(item.deadline)), 3))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(item.module?.category || 'Online-Fortbildung'), 1),
                    _createElementVNode("h3", _hoisted_21, _toDisplayString(item.module?.title), 1),
                    _createElementVNode("p", _hoisted_22, _toDisplayString(item.module?.description), 1),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, "⏱ " + _toDisplayString(item.module?.duration_minutes) + " Min.", 1),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(item.module?.category), 1)
                    ]),
                    _createElementVNode("button", _hoisted_26, _toDisplayString(_ctx.isCompleted(item.courseId) ? 'Nochmals starten' : 'Kurs starten'), 1)
                  ], 10, _hoisted_15))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myInstructions, (entry) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'instruction-' + entry.instruction.instructionId,
                    class: _normalizeClass(["module-card instruction-card", { completed: entry.confirmed }]),
                    onClick: ($event: any) => (_ctx.openInstruction(entry.instruction.instructionId))
                  }, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_file_text_icon, { size: "46" })
                    ]),
                    (entry.confirmed)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, "Bestätigt ✓"))
                      : _createCommentVNode("", true),
                    (entry.deadline)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["module-card__deadline", { overdue: _ctx.isOverdue(entry.deadline) }])
                        }, " Frist: " + _toDisplayString(_ctx.formatDate(entry.deadline)), 3))
                      : _createCommentVNode("", true),
                    _hoisted_30,
                    _createElementVNode("h3", _hoisted_31, _toDisplayString(entry.instruction.title), 1),
                    _createElementVNode("p", _hoisted_32, _toDisplayString(entry.instruction.fileName), 1),
                    _createElementVNode("button", _hoisted_33, _toDisplayString(entry.confirmed ? 'Erneut ansehen' : 'Lesen & bestätigen'), 1)
                  ], 10, _hoisted_27))
                }), 128))
              ]))
        ], 64))
  ]))
}